<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="maintainTask">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i>AI查询
        </span>
        <div class="w_normalNav" :parent="self">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
          <!-- <button class="GreenSmBtn" @click="openDialog">批量导出</button> -->
        </div>
        <div class="searchForm1">
          <searchForm :items="items" :formPlus="form_jsgl" ref="searchForm_jsgl">
            <template slot="last">
              <el-form-item label="用户名称:">
                <el-select placeholder="请选择用户" v-model="seefrom.userId " >
                  <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="状态:">
                <el-select placeholder="请选择状态" v-model="seefrom.status" >
                  <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="开始时间:" label-width="115px">
                <el-date-picker v-model="seefrom.startTime " value-format="yyyy-MM-dd" type="date" placeholder="请选择开始时间">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="结束时间:" label-width="115px">
                <el-date-picker v-model="seefrom.endTime" value-format="yyyy-MM-dd" type="date" placeholder="请选择结束时间">
                </el-date-picker>
              </el-form-item>
              <br>
            </template>
          </searchForm>
        </div>
        <div class="tableWrapper">
          <el-table :data="tableData" style="width: 100%" class="stripeTable" height="500" ref="Table">
            <el-table-column show-overflow-tooltip :label="label" :prop="prop" :align="align" :width="width" v-for="({prop,label,align, width}) in config" :key="prop.toString()"></el-table-column>
            <el-table-column label="操作" width="170">
              <template slot-scope="scope">
                <el-link icon="iconfont iconcheck" type="text" size="small" @click="check(scope.$index,  scope.row)">详情
                </el-link>
                <el-link icon="iconfont iconedit" type="text" size="small" @click="download(scope.row)">导出</el-link>
              </template>
            </el-table-column>
          </el-table>
          <div class="footer">
            <el-pagination layout="prev, pager, next" :page-size="10" @current-change="handleCurrentChange" :total="nTotal" :current-page="currentPage">
            </el-pagination>
          </div>
        </div>
      </el-tab-pane>
      <!-- 批量导出 -->
      <ledger-dialog v-model="downloadDialog"></ledger-dialog>
      <el-dialog :visible.sync="detailDialog" class="cust_dialog editDialog" title="AI查询详情" width="80%">
        <el-form :model="detail" class="addDetail" ref="detail" label-suffix="：" style="margin: 0 40px 0 20px;">
          <el-col :span="12">
            <el-form-item label="提问时间" prop="llmCreateTime">
            <p>{{ detail.llmCreateTime }}</p>
          </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="提问人员" prop="llmUserName">
            <p>{{ detail.llmUserName }}</p>
          </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态" prop="llmStatus">
            <p>{{ detail.llmStatus==='0'?'未点评':'已点评'}}</p>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="点评时间" prop="llmCreateTime">
            <p>{{ detail.llmCreateTime}}</p>
            </el-form-item>
          </el-col>
          <el-form-item label="问题" prop="llmQuestion">
            <p>{{ detail.llmQuestion }}</p>
          </el-form-item>
          <el-form-item label="LLM答复" prop="llmAnswerText">
            <p>{{ detail.llmAnswerText }}</p>
          </el-form-item>
          <el-form-item label="llm图片" prop="llmAnswerPicture">
            <el-image
              v-if="detail.llmAnswerPicture"
              style="width: 300px;aspect-ratio: 3 / 2;"
              :src="'data:image/jpeg;base64,'+detail.llmAnswerPicture"
              :zoom-rate="1.2"
              :max-scale="7"
              :min-scale="0.2"
              :preview-src-list="['data:image/jpeg;base64,'+detail.llmAnswerPicture]"
              :initial-index="4"
              fit="cover"
            />
          </el-form-item>
          <el-form-item label="评分" prop="llmScore">
            <p>{{ detail.llmScore }}</p>
          </el-form-item>
          <el-form-item label="点评" prop="llmComment">
            <p>{{ detail.llmComment }}</p>
          </el-form-item>
          
          
        </el-form>
      </el-dialog>
    </el-tabs>
  </div>
</template>

<script>
import ledgerDialog from './ledgerDialog'
import { date } from 'utils'
export default {
  name: 'maintainTask',
  data() {
    return {
      form_jsgl: {},
      items: [],
      userList:[],
      statusList: [
        {
          label: '未评论',
          value: 0
        },
        {
          label: '已评论',
          value: 1
        },
      ],
      deviceList: [],
      tabName: 'maintainTask',
      seefrom: {},
      tableData: [],
      nTotal: 0,
      currentPage: 1,
      currentSize: 10,
      downloadDialog: false,
      detailDialog: false,
      detail: {}
    }
  },
  computed: {
    self() {
      return this
    },
    config() {
      return [
        {
          prop: 'llmCreateTime',
          label: '提问时间'
        },
        {
          prop: 'llmUserName',
          label: '提问人员'
        },
        {
          prop: 'llmStatusName',
          label: '状态'
        },
        {
          prop: 'llmQuestion',
          label: '问题'
        },
      ]
    }
  },
  components: {
    normalNav: () => import('public/normalNav'),
    searchForm: () => import('public/searchForm'),
    easyTable: () => import('public/easyTable'),
    ledgerDialog
  },
  methods: {
    getUserList() {
      this.$axiosget(`manager/company/getCompanUserListByCompanyId?companyId=${localStorage.getItem('companyId')}`).then((res) => {
        if (res.data.status == 10000) {
          this.userList = res.data.data
        }
      })
    },
    //搜索
    subSeefrom() {
      this.currentPage = 1
      this.getTableData()
    },
    //重置
    reset() {
      this.seefrom = {}
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getTableData()
    },
    // 每页数
    sizeChangeHandle(val) {
      this.currentSize = val
      this.currentPage = 1
      this.getTableData()
    },
    isMaxGtMin() {
      if (!this.seefrom.beginTime || !this.seefrom.endTime) return true
      let s = date(this.seefrom.beginTime)
      let e = date(this.seefrom.endTime)
      let ns = [s.YY, s.MM, s.DD].join('')
      let ne = [e.YY, e.MM, e.DD].join('')
      return ne > ns ? true : false
    },
    //查询表格数据
    getTableData() {
      if (this.seefrom.beginTime && this.seefrom.endTime) {
        if (!this.isMaxGtMin()) {
          this.$notify({
            message: '开始时间需小于结束时间',
            type: 'warning'
          })
          return
        }
      }
      this.$axiosget('operation/aiLLm/page', {
        params: {
          pageSize: this.currentSize,
          pageNum: this.currentPage,
          ...this.seefrom,
          startTime: this.seefrom.startTime
            ? this.seefrom.startTime + ' 00:00:00'
            : undefined,
          endTime: this.seefrom.endTime
            ? this.seefrom.endTime + ' 23:59:59'
            : undefined
        }
      }).then((res) => {
        if (res.data.data.list.length) {
          this.tableData=res.data.data.list
        } else {
          this.tableData = []
        }
        this.nTotal = res.data.data.total
      })
    },
    changeTab(val) {
      this.activeName = val
    },
    check(index, row) {
      this.$axiosget(`operation/aiLLm/detail?id=${row.id}`).then(
        (res) => {
          if (res.data.status == 10000) {
            this.detail = res.data.data
            this.detailDialog = true
          }
        }
      )
    },
    download(row) {
      this.$axiospost(
        `operation/aiLLm/export/${
          row.id
        }?companyId=${localStorage.getItem(
          'companyId'
        )}&userId=${localStorage.getItem('userId')}`,
        {
          headers: { 'Content-Type': 'application/x-msdownload' }
        }
      ).then((res) => {
        this.$message.success('下载成功!')
      })
    },
    openDialog() {
      this.downloadDialog = true
    }
  },
  created() {
    this.getUserList()
    this.getTableData()
  }
}
</script>

<style lang="less">
.w_normalNav {
  padding-top: 10px;
  height: 52px;
  position: absolute;
  top: -52px;
  right: 32px;
  z-index: 99;
}
.el-input__inner:focus {
  border: 1px solid #3587c7;
}
</style>

<style lang="less" scoped>
.cust_dialog /deep/ .el-dialog__body {
  padding-top: 35px;
  
}
.cust_dialog {
  /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute4/dataAnalysis/aiQuery/AiQuery.vue